export default "__VITE_ASSET__DMsY9jw7__"